// extracted by mini-css-extract-plugin
module.exports = {"actual":"a10a3f92e9--actual--KF2Fy","label":"a10a3f92e9--label--DSBoP"};